import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content.types";
import { PostContent } from "PFApp/components/card_tx/content/post_content";
import { Footer } from "PFApp/components/card_tx/footer/footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type DefaultVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "handleShare" | "handleRefetchActivities"
>;

export const DefaultVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleRefetchActivities
}: DefaultVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <PostContent activity={activity} />
      <Footer participants={activity.participants} />
    </>
  );
};
